import React from "react";
import { Button, Modal } from "react-bootstrap";

import ModalDialog from "../../common/ModalDialog";


type OwnProps = {
    /** Names of the to-be-pasted structures that already exist in the target structure set. */
    collidingNames: string[],
    /** Overwrite the existing structures with the pasted ones. */
    onOverwrite: () => void,
    /** Paste the structures as separate copies (existing structures are kept). */
    onAddAsCopies: () => void,
    /** Cancel the whole paste operation without changing anything. */
    onCancel: () => void,
};

class ConfirmPasteRoiDialog extends React.PureComponent<OwnProps> {

    getMessage = () => {
        const names = this.props.collidingNames;
        const label = names.join(', ');

        if (names.length > 1) {
            return `The target structure set already contains ${names.length} structures with the same names: ${label}. `
                + `Overwrite them, add the pasted structures as separate copies, or cancel the whole paste?`;
        } else {
            return `The target structure set already contains a structure called '${label}'. `
                + `Overwrite it, add the pasted structure as a separate copy, or cancel the whole paste?`;
        }
    }

    // Keyboard behaviour: Esc cancels via the Modal's built-in keyboard handling
    // (onHide -> onCancel). Enter is safe against accidental keypresses because the
    // modal autofocuses its container, not a button -- don't add autoFocus to the
    // destructive "Overwrite existing" button.

    render() {
        const single = this.props.collidingNames.length === 1;

        return (
            <ModalDialog
                size='lg'
                show={true}
                onHide={this.props.onCancel}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Paste structures</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {this.getMessage()}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={this.props.onOverwrite}>Overwrite existing</Button>
                    <Button variant="primary" onClick={this.props.onAddAsCopies}>{single ? "Add as copy" : "Add as copies"}</Button>
                    <Button variant="light" onClick={this.props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </ModalDialog>
        );
    }
}

export default ConfirmPasteRoiDialog;
